import React, { useState } from 'react';
import { useDatasourceId } from '@/hooks';
import { useGetSubscriptionQuery } from '@/features/subscription/apiSlice';
import AjaxSpinner from '@/components/AjaxSpinner';
import flex from '@/css/module/flex.css';
import css from '@/css/module/billing.css';
import { ManageSubscription } from '@/features/subscription/components/Billing/ManageSubscription';
import NewSubscriptionSuccess from '@/components/billing/NewSubscriptionSuccess';
import {
  getIsCreditPricing,
  successMessage,
} from '@/features/subscription/components/utils';
import {
  START_NEW,
  SubscriptionViewSelect,
} from '@/features/subscription/components/subcomponents/SubscriptionViewSelect';
import { useSelector } from 'react-redux';

const Billing: React.FC = () => {
  const datasourceId = useDatasourceId();
  const { data: subscription, isFetching } =
    useGetSubscriptionQuery(datasourceId);
  const isCreditPricing = useSelector(getIsCreditPricing);

  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const [subscriptionView, setSubscriptionView] = useState(START_NEW);

  const onActivation = () => {
    successMessage('Subscription activated!');
    setShowSuccessPage(true);
  };

  if (showSuccessPage) {
    return <NewSubscriptionSuccess />;
  }

  const isLoading =
    (isFetching && subscription?.subscriptionStatus) || !subscription;

  if (isLoading) {
    return (
      <div className={flex.middleOfVP}>
        <AjaxSpinner message="Loading subscription info" />
      </div>
    );
  }
  return (
    <div className={css.container}>
      <div className={css.inner}>
        <div className={css.titleContainer}>
          <h1>
            {subscription.subscriptionStatus
              ? 'Billing'
              : 'Activate subscription'}
          </h1>
        </div>

        {!subscription.subscriptionStatus && isCreditPricing && (
          <SubscriptionViewSelect
            subscriptionView={subscriptionView}
            onSelect={setSubscriptionView}
            onActivation={onActivation}
          />
        )}
        {subscriptionView === START_NEW && (
          <ManageSubscription
            subscription={subscription}
            onActivation={onActivation}
          />
        )}
      </div>
    </div>
  );
};

export default Billing;
